// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3-up0","text":"SelectPayment_text__nYzHi","title":"SelectPayment_title__3zxv6","btn":"SelectPayment_btn__1ThWr"};